declare const SENTRY_RELEASE: string; // defined only at build time
import * as Sentry from "@sentry/angular";
import { environment } from "@environments/environment";
import { TSentryEnv } from "./sentry-env.type";

const release = typeof SENTRY_RELEASE !== "undefined" ? SENTRY_RELEASE : undefined;

export const sentryEnv: TSentryEnv = {
  enabled: true,
  options: {
    dsn: "",
    environment: "production",
    release,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.graphqlClientIntegration({ endpoints: [environment.graphql_endpoint] }),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      Sentry.feedbackIntegration({
        colorScheme: "light",
        showBranding: false,
        autoInject: false,
      }),
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    profilesSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true,
    tracePropagationTargets: [environment.graphql_endpoint, environment.url, environment.REALTIME_SOCKET_URL],
  },
};
